import axios from "axios";
import { API_URL } from "@/config";

const base = `${API_URL}/transport`;

// ─── Auth ──────────────────────────────────────────────────────────────────
export const loginTransport = (email: string, password: string) =>
    axios.post(`${base}/auth/login`, { email, password }, { withCredentials: true });

export const logoutTransport = () =>
    axios.post(`${base}/auth/logout`, {}, { withCredentials: true });

export const getCurrentTransport = () =>
    axios.get(`${base}/auth/me`, { withCredentials: true });

// ─── Transport Company ─────────────────────────────────────────────────────
export const getTransportStats = () =>
    axios.get(`${base}/stats`, { withCredentials: true }).then((r) => r.data);

export const getMyShipments = (status?: string) =>
    axios.get(`${base}/shipments`, {
        params: status ? { status } : {},
        withCredentials: true,
    }).then((r) => r.data);

export const updateShipmentStatus = (shipmentId: number, status: string) =>
    axios.patch(`${base}/shipments/${shipmentId}/status`, { status }, { withCredentials: true }).then((r) => r.data);

// ─── Dealer ────────────────────────────────────────────────────────────────
export const createShipment = (data: {
    transport_company_id: number;
    vehicle_vin?: string;
    pickup_location?: string;
    dropoff_location?: string;
    scheduled_date?: string;
}) => axios.post(`${base}/dealer/shipments`, data, { withCredentials: true }).then((r) => r.data);

export const getDealerShipments = () =>
    axios.get(`${base}/dealer/shipments`, { withCredentials: true }).then((r) => r.data);

export const getLinkedTransportCompanies = () =>
    axios.get(`${base}/dealer/partners`, { withCredentials: true }).then((r) => r.data);

// ─── Admin ─────────────────────────────────────────────────────────────────
export const adminListTransportCompanies = () =>
    axios.get(`${API_URL}/admin/transport/companies`, { withCredentials: true }).then((r) => r.data);

export const adminCreateTransportCompany = (data: {
    company_name: string; company_code: string; email: string; password: string;
    phone?: string; contact_name?: string; mc_number?: string; dot_number?: string;
    operating_states?: string; notes?: string;
}) => axios.post(`${API_URL}/admin/transport/companies`, data, { withCredentials: true }).then((r) => r.data);

export const adminUpdateTransportStatus = (id: number, status: string) =>
    axios.patch(`${API_URL}/admin/transport/companies/${id}/status`, { status }, { withCredentials: true }).then((r) => r.data);
